import { createAction } from '@reduxjs/toolkit';

export interface MethodsEligibilityMap {
  [key: string]: boolean;
}

export const getPayPalMethodsEligibility = (): MethodsEligibilityMap => {
  const PAYPAL_FUNDINGS = [
    window.paypal.FUNDING.PAYPAL,
    window.paypal.FUNDING.PAYLATER,
    window.paypal.FUNDING.VENMO,
    window.paypal.FUNDING.CREDIT,
  ];
  const fundingMap = PAYPAL_FUNDINGS.reduce<MethodsEligibilityMap>((acc, fundingSource) => {
    acc[fundingSource] = window.paypal.Buttons({ fundingSource }).isEligible();
    return acc;
  }, {});
  return fundingMap;
};

export const checkPayPalMethodsEligibility = createAction('CHECK_PAYPAL_METHODS_ELIGIBILITY', () => {
  return {
    payload: getPayPalMethodsEligibility(),
  };
});
